const DEFAULT_SECTIONS = {
  todo: {
    order: 0,
    visible: true,
    without_label: {
      order: 0,
      visible: true,
      EventsForToday: { order: 0, visible: true, expanded: false },
      UnassignedInquiries: { order: 1, visible: true, expanded: false },
      ContactsToReachOut: { order: 2, visible: true, expanded: false },
      ListingsAlertsErrors: { order: 3, visible: true, expanded: false },
      OverviewTasks: { order: 4, visible: true, expanded: false },
      VisitsToConfirm: { order: 5, visible: true, expanded: false },
      PropertiesPendingReview: { order: 6, visible: true, expanded: false },
      DevelopmentsPendingReview: { order: 7, visible: true, expanded: false },
    },
    UpcomingExpirations: {
      order: 1,
      visible: true,
      LeadsToExpire: { order: 0, visible: true, expanded: false },
      ReservationsToExpire: { order: 1, visible: true, expanded: false },
      RentToExpire: { order: 2, visible: true, expanded: false },
      ExclusivityToExpire: { order: 3, visible: true, expanded: false },
    },
  },
  overview: {
    order: 1,
    visible: true,
    mini_cards: {
      order: 0,
      visible: true,
      ActiveContacts: { order: 0, visible: true, expanded: false },
      Properties: { order: 1, visible: true, expanded: false },
      AvailableDevelopments: { order: 2, visible: true, expanded: false },
    },
    CountActiveContacts: {
      order: 1,
      visible: true,
      ContactSource: { order: 0, visible: true, expanded: false },
      OverviewTasks: { order: 1, visible: true, expanded: false },
      Leads: { order: 2, visible: true, expanded: false },
      PendingScheduledEvents: { order: 3, visible: true, expanded: false },
      Showings: { order: 4, visible: true, expanded: false },
      ContactsLastUpdate: { order: 5, visible: true, expanded: false },
    },
    CountAvailableProperties: {
      order: 2,
      visible: true,
      TotalValueCurrency: { order: 0, visible: true, expanded: false },
      Operation: { order: 1, visible: true, expanded: false },
      PropertyType: { order: 2, visible: true, expanded: false },
      Location: { order: 3, visible: true, expanded: false },
      ConstructionAge: { order: 4, visible: true, expanded: false },
      EntryDate: { order: 5, visible: true, expanded: false },
      PropertiesLastUpdate: { order: 6, visible: true, expanded: false },
      QPrecoMarketplace: { order: 7, visible: true, expanded: false },
      MarketplaceRegistrationQuality: {
        order: 8,
        visible: true,
        expanded: false,
      },
    },
    CountAvailableDevelopments: {
      order: 3,
      visible: true,
      DevelopmentType: { order: 0, visible: true, expanded: false },
      CountDevelopmentsInLocations: {
        order: 1,
        visible: true,
        expanded: false,
      },
    },
  },
  performance: {
    order: 2,
    visible: true,
    mini_cards: {
      order: 0,
      visible: true,
      InquiriesReceived: { order: 0, visible: true, expanded: false },
      NewContacts: { order: 1, visible: true, expanded: false },
      ResponseTime: { order: 2, visible: true, expanded: false },
      VisitsMade: { order: 3, visible: true, expanded: false },
      ConversionRate: { order: 4, visible: true, expanded: false },
      ConversionTime: { order: 5, visible: true, expanded: false },
      AddedProperties: { order: 6, visible: true, expanded: false },
      ConcretedOperations: { order: 7, visible: true, expanded: false },
    },
    without_label: {
      order: 1,
      visible: true,
      InquiriesReceived: { order: 0, visible: true, expanded: false },
      NewContacts: { order: 1, visible: true, expanded: false },
    },
    SearchTrends: {
      order: 2,
      visible: true,
      MostInquiredProperties: { order: 0, visible: true, expanded: false },
      LeastInquiredProperties: { order: 1, visible: true, expanded: false },
      MostInquiredDevelopments: { order: 2, visible: true, expanded: false },
      LeastInquiredDevelopments: { order: 3, visible: true, expanded: false },
    },
    ContactManagement: {
      order: 3,
      visible: true,
      ResponseTime: { order: 0, visible: true, expanded: false },
      ResponseTimeEvolution: { order: 1, visible: true, expanded: false },
      VisitsMade: { order: 2, visible: true, expanded: false },
      VisitsMadeEvolution: { order: 3, visible: true, expanded: false },
      EventsMade: { order: 4, visible: true, expanded: false },
      ReservationsCreated: { order: 5, visible: true, expanded: false },
      ConversionRate: { order: 6, visible: true, expanded: false },
      ConversionTime: { order: 7, visible: true, expanded: false },
      ClosedLeads: { order: 8, visible: true, expanded: false },
      AgentsPerformance: {
        order: 9,
        visible: true,
        expanded: true,
        alwaysExpanded: true,
      },
    },
    PropertyProduction: {
      order: 4,
      visible: true,
      ProductionRate: { order: 0, visible: true, expanded: false },
      AddedProperties: { order: 1, visible: true, expanded: false },
    },
    ConcretedProduction: {
      order: 5,
      visible: true,
      ConcretedOperations: { order: 0, visible: true, expanded: false },
      ConcretedOperationsSource: { order: 1 },
      ConcretedOperationsEvolution: {
        order: 2,
        visible: true,
        expanded: true,
        alwaysExpanded: true,
      },
    },
  },
};

export default DEFAULT_SECTIONS;
